import { AbstractRouterFilter, addUrlParams } from '@zk/framework-vue';

export default class ShareTokenFilter extends AbstractRouterFilter {

  // 分享key属性
  static shareKeyProp = 'shareCode';
  // 输入密码页面
  shareLoginPage = 'share-login';
  shareExpiredPage = 'share-expired'
  // 分享重定向key
  static shareRedirectKey = 'share-redirect';

  order() {
    return super.order() + 3;
  }

  matches(to) {
    return to.name === this.shareExpiredPage || to.meta?.share && to.query[ShareTokenFilter.shareKeyProp]?.length;
  }

  async onBefore(to) {
    if (this.isShareLoginPage(this.shareExpiredPage, to)) {
      return true;
    }

    const { [ShareTokenFilter.shareKeyProp]: shareCode } = to.query;
    try {
      await this.option.store.dispatch('user/loadShareInfo', { shareCode });
    } catch {
      return { name: this.shareExpiredPage };
    }

    const token = this.getToken(shareCode);
    const isLoginPage = this.isShareLoginPage(this.shareLoginPage, to);
    // 是否有token
    if (!token) {
      if (isLoginPage) {
        return true;
      }
      return this.toShareLoginPage(this.shareLoginPage, to, to.query);
    }
    if (isLoginPage) {
      const { query: { [[ShareTokenFilter.shareRedirectKey]]: redirectUrl } } = to;
      return ShareTokenFilter.redirect(redirectUrl);
    }
    return true;
  }
  /**
   * 获取token
   * @returns {*}
   */
  getToken(shareCode) {
    const token = sessionStorage.getItem(`token-share-${shareCode}`);
    token && this.option.store.dispatch('user/shareAnonymousLogin', { token, shareCode });
    return token;
  }

  static redirect(redirectUrl) {
    const isWebUrl = ShareTokenFilter.isWebUrl(redirectUrl);
    if (isWebUrl) {
      window.location.href = redirectUrl;
      return false;
    }
    return redirectUrl;
  }

  /**
   * 去分享登录页面
   * @param page
   * @param to
   * @param query
   * @returns {boolean|{query, name}}
   */
  toShareLoginPage(page, to, query) {
    const isWebUrl = ShareTokenFilter.isWebUrl(page);
    const q = {
      ...query,
      [ShareTokenFilter.shareRedirectKey]: isWebUrl ? window.location.href : to.fullPath
    };

    if (isWebUrl) {
      window.location.href = addUrlParams(page, q);
      return false;
    }
    return {
      name: page,
      query: q
    };
  }

  /**
   * 判断当前页面是否为分享登录页面
   * @param page
   * @param to
   * @returns {boolean|*}
   */
  isShareLoginPage(page, to) {
    const isWebUrl = ShareTokenFilter.isWebUrl(page);
    if (isWebUrl) {
      return window.location.href.startsWith(page);
    }
    return to.name === page;
  }

  static isWebUrl(page) {
    return /[a-zA-z]+:\/\/[^\s]*/.test(page);
  }
}

